import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';
import { Observable } from 'rxjs';

@Injectable()
export class BearerInterceptor implements HttpInterceptor {
  constructor(protected keycloakService: KeycloakService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.keycloakService.getKeycloakInstance()?.token) {
      let isAwhy = request.url === 'https://research.awhy.it/pdf/read/';
      request = request.clone({
        setHeaders: {
          Authorization: !isAwhy
            ? `Bearer ${this.keycloakService.getKeycloakInstance().token}`
            : `Token fdf0baf831699e1885a3a03430eb800e1ee27813`,
        },
      });
    }
    return next.handle(request);
  }
}
